// extracted by mini-css-extract-plugin
export var breakpointXs = "550px";
export var busyContainer = "Button-module--busy-container--b97bc";
export var busyContainerActive = "Button-module--busy-container-active--58512";
export var busyContent = "Button-module--busy-content--e1021";
export var busySpinner = "Button-module--busy-spinner--ef5fb";
export var button = "Button-module--button--b1113";
export var colorGray = "#8e9287";
export var colorGrayDark = "#616161";
export var colorGrayDarker = "#272824";
export var colorGrayLight = "#e3e4e2";
export var colorGrayLighter = "#f2f3f2";
export var colorPrimary = "#a6ce3c";
export var colorSecondary = "#4f7802";
export var large = "Button-module--large--0886b";
export var primary = "Button-module--primary--b8701";
export var secondary = "Button-module--secondary--9bc82";
export var small = "Button-module--small--bfa5f";
export var spacingLg = "32px";
export var spacingMd = "32px";
export var spacingSm = "16px";
export var spacingXl = "128px";
export var spacingXs = "8px";
export var spacingXxs = "4px";